import Vue from "vue";
import sanitizeHTML from "sanitize-html";

// 金額表示
Vue.filter("addComma", function(val) {
  return val.toLocaleString();
});

// 改行
Vue.filter("applyBR", function(val) {
  if (!val) {
    return;
  }

  // sanitize (v-html で使用するなら必須)
  const sanitizedText = sanitizeHTML(val);
  return sanitizedText.replace(/\\n/g, "<br />");
});
